import type { PermissionsClaim } from "../typings/permissions";

export const getCurrentBitFlag = (
  claim: PermissionsClaim | null | undefined,
): number => {
  const flag = claim?.perm?._p;
  return typeof flag === "number" && Number.isInteger(flag) ? flag : 0;
};

export const hasPermission = (
  permissionClaim: PermissionsClaim | null | undefined,
  bitFlag: number,
): boolean => {
  const userPermissionFlag = getCurrentBitFlag(permissionClaim);
  return userPermissionFlag !== 0 && (userPermissionFlag & bitFlag) === bitFlag;
};
